import {
  FaBuilding,
  FaExpand,
  FaHome,
  FaKey,
  FaRupeeSign,
} from "react-icons/fa";
import { formatPrice } from "../../../utils/helpers";
import PropertyDetailsHeaderSection from "../userCommon/PropertyDetailsHeaderSection";
import PropertyDetailsMediaSection from "../userCommon/PropertyDetailsMediaSection";

const PropertyCard = ({ property }) => {
  if (!property) {
    return (
      <div className="text-center py-10 text-gray-500">
        No property data available.
      </div>
    );
  }

  const formatStatus = (status) => {
    if (!status) return "N/A";
    return status
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  const { title, location, images, property: propertyDetails } = property;

  const { ownership, availabilityStatus, floorPlan } = propertyDetails || {};

  return (
    <div className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm">
      <div className="mx-auto bg-white px-3 sm:px-4 md:px-6 lg:px-8 xl:px-10 py-4 sm:py-6">
        <PropertyDetailsHeaderSection
          displayTitle={title}
          location={location}
        />

        <PropertyDetailsMediaSection images={images} />

        <div className=" py-2">
          <div className="border border-gray-300 p-2 py-4 rounded-xl bg-gray-50">
            {/* Price Section */}
            <div className="mb-4 p-4 rounded-lg flex items-center border-b border-gray-200 bg-white shadow-sm">
              <FaRupeeSign className="text-green-600 mr-3 text-lg" />
              <span className="font-poppins font-semibold text-[19px] text-[#031722]">
                {formatPrice(propertyDetails?.floorPlan?.expectedPrice)}
              </span>
              {floorPlan?.conditions?.allInclusivePrice && (
                <span className="ml-3 text-[#858585] text-[13px]">
                  All Inclusive Price
                </span>
              )}
            </div>

            {/* Key Property Info Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 mb-4 bg-white rounded-lg shadow-sm p-4 border-b border-gray-200">
              {/* Project Status */}
              <div className="flex items-center">
                <FaBuilding className="text-blue-600 mr-3" />
                <div>
                  <p className="text-[#858585] text-[13px]">Project Status</p>
                  <p className="text-[#383838] font-medium">
                    {formatStatus(propertyDetails?.availabilityStatus) || "N/A"}
                  </p>
                </div>
              </div>

              {/* Ownership */}
              <div className="flex items-center">
                <FaKey className="text-blue-600 mr-3" />
                <div>
                  <p className="text-[#858585] text-[13px]">Ownership</p>
                  <p className="text-[#383838] font-medium">
                    {formatStatus(ownership) || "N/A"}
                  </p>
                </div>
              </div>

              {/* Availability */}
              <div className="flex items-center">
                <FaHome className="text-blue-600 mr-3" />
                <div>
                  <p className="text-[#858585] text-[13px]">Availability</p>
                  <p className="text-[#383838] font-medium">
                    {formatStatus(availabilityStatus) || "N/A"}
                  </p>
                </div>
              </div>
            </div>

            {/* Unit Configuration */}
            <div className="flex items-center bg-white shadow-sm rounded-lg p-4">
              <FaExpand className="text-blue-600 mr-3" />
              <div className="flex flex-wrap items-center gap-4">
                <div>
                  <p className="text-[#858585] text-[13px]">
                    Unit Configuration
                  </p>
                  <p className="text-[#383838] font-medium">
                    {floorPlan?.bhk
                      ? `${floorPlan?.bhk} BHK`
                      : "Configuration not specified"}
                  </p>
                </div>
                <div className="h-6 w-px bg-gray-300"></div>
                <div>
                  <p className="text-[#858585] text-[13px]">Size</p>
                  <p className="text-[#383838] font-medium">
                    {floorPlan?.carpetArea?.value
                      ? `${floorPlan.carpetArea.value} ${floorPlan.carpetArea.unit}`
                      : "N/A"}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PropertyCard;
// import React, { useState } from "react";
// import {
//   FaMapMarkerAlt,
//   FaRupeeSign,
//   FaBuilding,
//   FaKey,
//   FaHome,
//   FaExpand,
// } from "react-icons/fa";
// import { formatPrice } from "../../../utils/helpers";

// const PropertyCard = ({ property }) => {
//   const defaultImage =
//     property?.images?.[0]?.url || "https://via.placeholder.com/600x400";
//   const [mainImage, setMainImage] = useState(defaultImage);

//   if (!property) {
//     return (
//       <div className="text-center py-10 text-gray-500">
//         No property data available.
//       </div>
//     );
//   }

//   const formatStatus = (status) => {
//     if (!status) return "N/A";
//     return status
//       .split("_")
//       .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
//       .join(" ");
//   };

//   // destructure data
//   const { title, location, images, property: propertyDetails } = property;

//   const { ownership, availabilityStatus, floorPlan } = propertyDetails || {};

//   return (
//     <div
//       className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm"
//       data-aos="fade-up"
//     >
//       {/* 🏠 Property Header Section */}
//       <div className="p-2 sm:p-6 pb-2">
//         <h2 className="font-medium text-[#031722] tracking-[0.01em] leading-[150%] text-xl sm:text-2xl md:text-3xl xl:text-[24px] mb-2 sm:mb-3 md:mb-4">
//           {title}
//         </h2>
//         <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 flex-wrap">
//           <p className="font-normal text-[#8A8A8A] flex justify-between text-sm sm:text-base md:text-lg xl:text-[18px]">
//             {location?.address?.formatted}
//             <span className="ml-3 text-blue-600 hover:text-blue-800 flex items-center cursor-pointer transition-colors">
//               <FaMapMarkerAlt className="mr-1" /> See on Map
//             </span>
//           </p>
//         </div>
//       </div>

//       {/*    Property Image Gallery */}
//       <div className="relative flex flex-col md:flex-row gap-4 px-2 md:px-4 lg:px-6">
//         {/* Main Image */}
//         <div className="w-full md:w-[78%] md:h-[310px] xl:h-[330px] bg-gray-200 rounded-xl overflow-hidden shadow-md">
//           <img
//             src={mainImage}
//             alt={title}
//             className="w-full h-auto object-cover hover:scale-105 transition-transform duration-500"
//           />
//         </div>

//         {/* Thumbnail Images */}
//         <div className="w-full md:w-[22%] flex flex-row md:flex-col justify-between gap-3">
//           {images?.slice(1, 4).map((img, index) => (
//             <div
//               key={index}
//               className="w-1/3 md:w-full h-24 bg-gray-200 rounded-xl overflow-hidden shadow-md hover:shadow-lg cursor-pointer transition-shadow"
//               onClick={() => setMainImage(img.url)}
//             >
//               <img
//                 src={img.url}
//                 alt={`Thumbnail ${index + 1}`}
//                 className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
//               />
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* 💰 Property Details Section */}
//       <div className="px-2 md:px-4 lg:px-6 py-2">
//         <div className="border border-gray-300 p-2 py-4 rounded-xl bg-gray-50">
//           {/* Price Section */}
//           <div className="mb-4 p-4 rounded-lg flex items-center border-b border-gray-200 bg-white shadow-sm">
//             <FaRupeeSign className="text-green-600 mr-3 text-lg" />
//             <span className="font-poppins font-semibold text-[19px] text-[#031722]">
//               {formatPrice(propertyDetails?.floorPlan?.expectedPrice)}
//             </span>
//             {floorPlan?.conditions?.allInclusivePrice && (
//               <span className="ml-3 text-[#858585] text-[13px]">
//                 All Inclusive Price
//               </span>
//             )}
//           </div>

//           {/* Key Property Info Grid */}
//           <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 mb-4 bg-white rounded-lg shadow-sm p-4 border-b border-gray-200">
//             {/* Project Status */}
//             <div className="flex items-center">
//               <FaBuilding className="text-blue-600 mr-3" />
//               <div>
//                 <p className="text-[#858585] text-[13px]">Project Status</p>
//                 <p className="text-[#383838] font-medium">
//                   {formatStatus(propertyDetails?.availabilityStatus) || "N/A"}
//                 </p>
//               </div>
//             </div>

//             {/* Ownership */}
//             <div className="flex items-center">
//               <FaKey className="text-blue-600 mr-3" />
//               <div>
//                 <p className="text-[#858585] text-[13px]">Ownership</p>
//                 <p className="text-[#383838] font-medium">
//                   {formatStatus(ownership) || "N/A"}
//                 </p>
//               </div>
//             </div>

//             {/* Availability */}
//             <div className="flex items-center">
//               <FaHome className="text-blue-600 mr-3" />
//               <div>
//                 <p className="text-[#858585] text-[13px]">Availability</p>
//                 <p className="text-[#383838] font-medium">
//                   {formatStatus(availabilityStatus) || "N/A"}
//                 </p>
//               </div>
//             </div>
//           </div>

//           {/* Unit Configuration */}
//           <div className="flex items-center bg-white shadow-sm rounded-lg p-4">
//             <FaExpand className="text-blue-600 mr-3" />
//             <div className="flex flex-wrap items-center gap-4">
//               <div>
//                 <p className="text-[#858585] text-[13px]">Unit Configuration</p>
//                 <p className="text-[#383838] font-medium">
//                   {floorPlan?.bhk
//                     ? `${floorPlan?.bhk} BHK`
//                     : "Configuration not specified"}
//                 </p>
//               </div>
//               <div className="h-6 w-px bg-gray-300"></div>
//               <div>
//                 <p className="text-[#858585] text-[13px]">Size</p>
//                 <p className="text-[#383838] font-medium">
//                   {floorPlan?.carpetArea?.value
//                     ? `${floorPlan.carpetArea.value} ${floorPlan.carpetArea.unit}`
//                     : "N/A"}
//                 </p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default PropertyCard;
